// // import { Menu, Button } from "@mantine/core";
// // import {
// //   IconUpload,
// //   IconEye,
// //   IconLink,
// //   IconFolder
// // } from "@tabler/icons-react";
// // import toast from "react-hot-toast";

// // interface Props {
// //   batchNo: string;
// //   onUpload: () => void;
// //   onView: () => void;
// // }

// // const AdminResourceActions = ({ batchNo, onUpload, onView }: Props) => {
// //   const copyLink = async () => {
// //     const url = `https://learn.thinkcloudly.com/batch-resource/?batch=${batchNo}`;
// //     await navigator.clipboard.writeText(url);
// //     toast.success("Resource link copied");
// //   };

// //   return (
// //     <Menu shadow="md" width={180}>
// //       <Menu.Target>
// //         <Button
// //           size="xs"
// //           variant="gradient"
// //           gradient={{ from: "indigo", to: "violet" }}
// //           leftSection={<IconFolder size={14} />}
// //         >
// //           Resources
// //         </Button>
// //       </Menu.Target>

// //       <Menu.Dropdown>
// //         <Menu.Item
// //           leftSection={<IconUpload size={14} />}
// //           onClick={onUpload}
// //         >
// //           Upload Files
// //         </Menu.Item>

// //         <Menu.Item
// //           leftSection={<IconEye size={14} />}
// //           onClick={onView}
// //         >
// //           View Files
// //         </Menu.Item>

// //         <Menu.Divider />

// //         <Menu.Item
// //           leftSection={<IconLink size={14} />}
// //           onClick={copyLink}
// //         >
// //           Copy Link
// //         </Menu.Item>
// //       </Menu.Dropdown>
// //     </Menu>
// //   );
// // };

// // export default AdminResourceActions;

// import React from "react";
// import { Menu, Button } from "@mantine/core";
// import {
//   IconUpload,
//   IconEye,
//   IconLink,
//   IconFolder,
// } from "@tabler/icons-react";
// import { showNotification } from "@mantine/notifications";

// interface AdminResourceActionsProps {
//   batchNo: string;
//   onUpload: () => void;
//   onView: () => void;
// }

// const AdminResourceActions: React.FC<AdminResourceActionsProps> = ({
//   batchNo,
//   onUpload,
//   onView,
// }) => {
//   const handleCopyLink = async () => {
//     try {
//       const resourceUrl = `https://learn.thinkcloudly.com/batch-resource/?batch=${batchNo}`;
//       await navigator.clipboard.writeText(resourceUrl);

//       showNotification({
//         title: "Link Copied",
//         message: "Resource link copied to clipboard",
//         color: "green",
//       });
//     } catch (error) {
//       showNotification({
//         title: "Error",
//         message: "Failed to copy resource link",
//         color: "red",
//       });
//     }
//   };

//   return (
//     <Menu shadow="md" width={190} withinPortal>
//       <Menu.Target>
//         <Button
//           size="xs"
//           variant="gradient"
//           gradient={{ from: "indigo", to: "violet" }}
//           leftSection={<IconFolder size={14} />}
//         >
//           Resources
//         </Button>
//       </Menu.Target>

//       <Menu.Dropdown>
//         <Menu.Item
//           leftSection={<IconUpload size={14} />}
//           onClick={onUpload}
//         >
//           Upload Resources
//         </Menu.Item>

//         <Menu.Item
//           leftSection={<IconEye size={14} />}
//           onClick={onView}
//         >
//           View Resources
//         </Menu.Item>

//         <Menu.Divider />

//         <Menu.Item
//           leftSection={<IconLink size={14} />}
//           onClick={handleCopyLink}
//         >
//           Copy Resource Link
//         </Menu.Item>
//       </Menu.Dropdown>
//     </Menu>
//   );
// };

// export default AdminResourceActions;

import React from "react";
import { Menu, ActionIcon, Tooltip } from "@mantine/core";
import {
  IconUpload,
  IconEye,
  IconLink,
  IconFolder,
} from "@tabler/icons-react";
import { showNotification } from "@mantine/notifications";

interface AdminResourceActionsProps {
  batchNo: string;
  onUpload: () => void;
  onView: () => void;
}

const AdminResourceActions: React.FC<AdminResourceActionsProps> = ({
  batchNo,
  onUpload,
  onView,
}) => {
  const handleCopyLink = async () => {
    try {
      const resourceUrl = `https://learn.thinkcloudly.com/batch-resource/?batch=${batchNo}`;
      await navigator.clipboard.writeText(resourceUrl);

      showNotification({
        title: "Link Copied",
        message: "Resource link copied to clipboard",
        color: "green",
      });
    } catch {
      showNotification({
        title: "Error",
        message: "Failed to copy resource link",
        color: "red",
      });
    }
  };

  return (
    <Menu shadow="md" width={200} withinPortal>
      <Menu.Target>
        <Tooltip label="Resources">
          <ActionIcon
            variant="light"
            color="violet"
            size="md"
          >
            <IconFolder size={18} />
          </ActionIcon>
        </Tooltip>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconUpload size={14} />}
          onClick={onUpload}
        >
          Upload Resources
        </Menu.Item>

        <Menu.Item
          leftSection={<IconEye size={14} />}
          onClick={onView}
        >
          View Resources
        </Menu.Item>

        <Menu.Divider />

        <Menu.Item
          leftSection={<IconLink size={14} />}
          onClick={handleCopyLink}
        >
          Copy Resource Link
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default AdminResourceActions;
